import CircularProgress from '@mui/material/CircularProgress';

/**
 * LoadingFallback Component
 *
 * Component that displays a loading spinner in the center of the screen.
 * @returns {JSX.Element} A centered loading spinner.
 */
function LoadingFallback(): JSX.Element {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        marginTop: 50
      }}
    >
      <CircularProgress />
    </div>
  );
}

export default LoadingFallback;
